





























































































import { defineComponent } from '@vue/composition-api';
import InputRules from '@/helpers/InputRulesHelper';
import CompanyRepository from '@/repositories/CompanyRepository';
import RemittanceScheduleRepository from '@/repositories/RemittanceScheduleRepository';
import ISelectOptions from '@/domain/interfaces/ISelectOptions';

export default defineComponent({
  name: 'UpdateRemittanceScheduleScheduleConfigModal',

  data() {
    const inputRules: InputRules = new InputRules();
    const remittanceScheduleConfigurationRepository = new RemittanceScheduleRepository();
    const companyRepository = new CompanyRepository();

    const bank: Number | null = null;
    const banks: ISelectOptions<number>[] = [];

    const selectedCompanies: number[] = [];
    const companyOptions: ISelectOptions<number>[] = [];

    return {
      inputRules,
      bank,
      selectedCompanies,
      banks,
      companyOptions,
      remittanceScheduleConfigurationRepository,
      companyRepository,
    };
  },

  props: {
    isUpdateBankModalOpen: {
      required: true,
      type: Boolean,
    },

    companyGroupId: {
      required: true,
      type: Number,
    },
  },

  created() {
    Promise.allSettled([
      this.loadBanks(),
      this.loadCompanies(),
    ]);
  },
  methods: {
    close() {
      this.$emit('close');
    },

    action() {
      this.$emit('update', {
        bank: this.bank,
        companies: this.selectedCompanies,
      });
    },

    async loadBanks() {
      try {
        const banks = await this.remittanceScheduleConfigurationRepository.getBanks(
          this.companyGroupId,
        );

        this.banks = banks.map((bank) => {
          const {
            banco, agencia, conta, id: value,
          } = bank;
          const text = `${banco} ${agencia} ${conta}`;
          return { text, value };
        });
      } catch (error) {
        this.$notification.error(
          'Houve um problema ao requisitar o banco do dia.',
        );
      }
    },

    async loadCompanies() {
      try {
        const companies = await this.companyRepository.getCompaniesByLoggedUser(
          this.companyGroupId,
        );

        this.companyOptions = companies.map(({ name, id }) => ({
          text: name,
          value: id,
        }));
      } catch (error) {
        this.$notification.error('Houve um problema ao requisitar as empresas do Usuário');
      }
    },
  },
});
